<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="cover" id="cover">
<img alt="The Adam Black Thrillers" class="cover-image" role="doc-cover" src="images/adam-black-1-5.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?274b9d8f